function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.643 17.643",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M15.577,7.109l-2.634-2.635l-5.717,5.719L5.691,14.82l4.583-1.577l5.717-5.718L15.577,7.109 L15.577,7.109z M6.599,13.901l0.846-2.703l1.831,1.831L6.599,13.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M17.575,5.621L14.846,2.89c-0.09-0.089-0.231-0.089-0.32,0L13.44,3.977 c-0.088,0.09-0.088,0.23,0,0.32l2.73,2.73c0.087,0.088,0.23,0.085,0.318,0l1.087-1.088C17.665,5.85,17.665,5.708,17.575,5.621z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#030104"
    },
    points: "0,14.819 5.031,14.819 5.477,13.591 0,13.591  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedaction);
export default __webpack_public_path__ + "static/media/redaction.2ed6715659681f6133d4d14f16fced55.svg";
export { ForwardRef as ReactComponent };